import {Component, OnDestroy, OnInit} from '@angular/core';
import {PhoneTransformer} from '../../services/transformer.service';
import {ProfileService} from 'app/views/profile/services/profile.service';
import {Http, RequestOptions, Headers, Response} from '@angular/http';
import {environment} from 'environments/environment';
import {ApiClientService} from '../../services/api-client.service';
import {AccountPermissionsService} from '../../services/account-permissions.service';
import {AuthTokenService} from '../../services/auth-token.service';

declare const $: any;
declare const swal: any;
declare const toastr: any;

@Component({
    templateUrl: 'profile.component.html',
    styleUrls: ['profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
    public id: number;
    public spinnerAvatar: boolean = false;
    public passwordData: Object = {
        current_password: '',
        plainPassword: {
            first: '',
            second: ''
        }
    };
    public residentEditMode = false;
    public originalData = null;
    public signatureEdit = false;

    public accountExpanded = false;
    public userProfileExpanded = true;
    public emergencyContactsExpanded = false;
    public vehiclesExpanded = false;
    public petsExpanded = false;
    public consentWaiversExpanded = false;

    public accountEditMode = false;
    public userProfileEditMode = false;
    public emergencyContactsEditMode = false;
    public vehiclesEditMode = false;
    public petsEditMode = false;
    public copiedObject: any = {};
    public disabledSubmit = false;
    public signatureCopy = '';

    static removeIds(entities: Array<any>) {
        entities.forEach(item => item.id && delete item.id);
    }

    constructor(
        public profile: ProfileService,
        public api: ApiClientService,
        public http: Http,
        public accountService: AccountPermissionsService,
        private authTokenService: AuthTokenService
    ) {
    }

    ngOnInit() {
        this.profile.data = null;
        this.profile.get().subscribe(() => {
            if (JSON.parse(localStorage.getItem('userData')).userType === 'resident')
                this.profile.getResidentProfileData();
        });
        this.profile.getPetTypes();
    }

    getPrimaryPhone(data: Array<any>): string | boolean {
        if (data && data.length) {
            const primaryPhone = data.find(item => item.isPrimaryPhone);

            if (primaryPhone) {
                return PhoneTransformer.stringToPhone(primaryPhone.phone);
            }
        }

        return false;
    }

    resetPhones(phones) {
        this.profile.data.phones = phones;
    }

    resetAddress(addresses) {
        this.profile.data.addresses = addresses;
    }

    resetPasswords() {
        this.passwordData = {
            current_password: '',
            plainPassword: {
                first: '',
                second: ''
            }
        };
    }

    update(data) {
        if (data.phones) ProfileComponent.removeIds(data.phones);
        if (data.addresses) ProfileComponent.removeIds(data.addresses);
        this.profile.update(data);
        this.residentEditMode = false;
    }

    toggleChangePasswordForm() {
        this.profile.isPasswordFormActive = !this.profile.isPasswordFormActive;
        this.resetPasswords();
    }

    changeAvatar(e) {
        this.spinnerAvatar = true;
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('File path should not be blank.');
                    return;
                }
                this.profile.data.avatar = res.path;
                if (this.profile.data.userType !== 'resident')
                    this.update({avatar: this.profile.data.avatar});
                this.spinnerAvatar = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.spinnerAvatar = false;
            }
        );
    }

    removeAvatar() {
        this.profile.data.avatar = '';
        if (this.profile.data.userType !== 'resident')
            this.update({avatar: this.profile.data.avatar});
    }

    setResidentEditMode(isEdit) {
        this.residentEditMode = isEdit;
        if (isEdit)
            this.originalData = JSON.parse(JSON.stringify(this.profile.data));
        else
            this.profile.data = JSON.parse(JSON.stringify(this.originalData));
    }

    clickResidentInfoChangesButton() {
        document.getElementById('submitResidentInfoChanges').click();
    }

    submitResidentInfoChanges(form) {
        const residentId = JSON.parse(localStorage.getItem('residentselectedBuilding')).residentBdId;
        const data = {
            fullName: form.value.fullName,
            email: form.value.email,
            phones: form.value.phones.filter(phone => phone.user = residentId),
            addresses: form.value.addresses.filter(address => address.user = residentId),
            dateOfBirth: form.value.dateOfBirth,
            photo: this.profile.data.avatar
        };

        this.update(data);
    }

    initSummernote() {
        this.signatureCopy = this.profile.data.signature;
        this.signatureEdit = true;
        setTimeout(() => {
            const summernote = $('#summernote');
            summernote.summernote({
                dialogsInBody: true,
                callbacks: {
                    onChange: contents => {
                        this.profile.data.signature = contents;
                    },
                    onImageUpload: (files, editor, welEditable) => {
                        this.uploadImage(files);
                    }
                },
                toolbar: [
                    ['style', ['style']],
                    ['fontsize', ['fontsize']],
                    ['color', ['color']],
                    ['font', ['bold', 'italic', 'underline', 'clear']],
                    ['fontname', ['fontname']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'hr', 'picture']],
                    ['help', ['help']]
                ],
                fontNames: ['Arial', 'open sans', 'Courier New'],
                disableDragAndDrop: true
            });
            $('.note-btn-bold').removeClass('active');
            $('.note-editable').html(this.profile.data.signature).on('focusout', e => {
                if ($(e.relatedTarget).closest('.note-toolbar').length) {
                    summernote.summernote('editor.saveRange');
                }
            });
        }, 0);
    }

    cancelSignatureEdit() {
        this.profile.data.signature = this.signatureCopy;
        this.closeSignatureEdit();
    }

    closeSignatureEdit() {
        this.signatureCopy = '';
        this.signatureEdit = false;
        $('#summernote').summernote('destroy');
    }

    submitSignature() {
        this.update({signature: this.profile.data.signature});
        this.closeSignatureEdit();
    }

    uploadImage(files) {
        const file = files[0];
        const fd = new FormData();

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('Attachment path should not be blank.');
                    return;
                }
                const image = $('<img>').attr('src', res.path).attr('style', 'max-width: 100%');
                $('#summernote').summernote('insertNode', image[0]);
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
            }
        );
    }

    ngOnDestroy(): void {
        this.profile.isPasswordFormActive = false;
    }

    changeWaiverSettings(event) {
        if (event.target.value == '1') {
            this.profile.showChangeWaiverSettingsModal = true;
            (<any>document.getElementsByName('consent')[0]).value = '0';
        } else {
            this.profile.saveResidentConsentDetails(false, null);
        }
    }

    turnEditModeOn(sectionName) {
        this[sectionName + 'EditMode'] = true;
        this[sectionName + 'Expanded'] = true;
        if (sectionName != 'emergencyContacts')
            this.copiedObject[sectionName] = this.profile.data[sectionName] ? JSON.parse(JSON.stringify(this.profile.data[sectionName])) : null;
        else {
            this.copiedObject[sectionName] = this.profile.data.userProfile.emergencyContacts ? JSON.parse(JSON.stringify(this.profile.data.userProfile.emergencyContacts)) : [];
            if (!this.profile.data.userProfile.emergencyContacts ||
                (this.profile.data.userProfile.emergencyContacts && this.profile.data.userProfile.emergencyContacts.length < 1)) {
                this.addNewContact();
                this.profile.data.userProfile.emergencyContacts[0].isPrimary = true;
            }
        }
        if (sectionName == 'userProfile') {
            this.copiedObject.phones = JSON.parse(JSON.stringify(this.profile.data.phones));
            this.copiedObject.addresses = JSON.parse(JSON.stringify(this.profile.data.addresses));
            this.copiedObject.avatar = JSON.parse(JSON.stringify(this.profile.data.avatar));
        }
        if (sectionName == 'pets' && (!this.profile.data[sectionName] || this.profile.data[sectionName].length < 1)) {
            this.profile.data[sectionName] = [{
                id: null,
                name: '',
                breed: '',
                weight: '',
                height: '',
                dateOfBirth: '',
                petType: '',
                note: ''
            }];
        } else if (sectionName == 'vehicles' && (!this.profile.data[sectionName] || this.profile.data[sectionName].length < 1)) {
            this.profile.data[sectionName] = [{
                id: null,
                brand: '',
                model: '',
                licensePlate: '',
                color: '',
                year: '',
                note: ''
            }];
        }
    }

    turnEditModeOff(sectionName) {
        this[sectionName + 'EditMode'] = false;
        if (sectionName != 'emergencyContacts') {
            this.profile.data[sectionName] = JSON.parse(JSON.stringify(this.copiedObject[sectionName]));
            if (sectionName == 'pets' && this.profile.data[sectionName].length < 1)
                this.petsExpanded = false;
            else if (sectionName == 'vehicles' && this.profile.data[sectionName].length < 1)
                this.vehiclesExpanded = false;
        } else {
            this.profile.data.userProfile.emergencyContacts = JSON.parse(JSON.stringify(this.copiedObject[sectionName]));
            if (!this.profile.data.userProfile.emergencyContacts || this.profile.data.userProfile.emergencyContacts.length < 1)
                this.emergencyContactsExpanded = false;
        }
        if (sectionName == 'userProfile') {
            this.profile.data.phones = JSON.parse(JSON.stringify(this.copiedObject.phones));
            this.profile.data.addresses = JSON.parse(JSON.stringify(this.copiedObject.addresses));
            this.profile.data.avatar = JSON.parse(JSON.stringify(this.copiedObject.avatar));
        }
        this.copiedObject = {};
    }

    updateSection(sectionName) {
        if (sectionName == 'vehicles' || sectionName == 'pets' || sectionName == 'userProfile') {
            if (!this.validateSection(sectionName))
                return;
        }
        if (sectionName == 'emergencyContacts') {
            if (!this.dataIsValid()) {
                return;
            }
        }
        this.profile.updateResidentInfoSection(sectionName).subscribe(res => {
            this.profile.data.previousPatch = res;
            toastr.success('Changes were successfully sent for approval.');
            this.turnEditModeOff(sectionName);
            this.profile.data.vehicles = [];
            this.profile.data.pets = [];
            this.profile.getResidentPatchedInfo();
            this.profile.getResidentProfileData();
        }, error => this.api.errorHandler(error, 'Failed to update information.'));
    }

    addNewItem(sectionName, index) {
        let item = null;
        if (sectionName == 'vehicles') {
            item = {
                brand: '',
                model: '',
                licensePlate: '',
                color: '',
                year: '',
                note: ''
            };
        } else if (sectionName == 'pets') {
            item = {
                name: '',
                breed: '',
                weight: '',
                height: '',
                dateOfBirth: null,
                petType: '',
                note: ''
            };
        }
        this.profile.data[sectionName].splice(index + 1, 0, item);
    }

    removeItem(array, index) {
        array.splice(index, 1);
    }

    getPetTypeName(id) {
        const type = this.profile.petTypes.find(t => t.id == id);
        return type ? type.name : '';
    }

    validateSection(sectionName) {
        let isValid = true;
        if (sectionName == 'vehicles') {
            this.profile.data[sectionName].forEach(i => {
                if (!i.licensePlate)
                    isValid = false;
            });
            if (!isValid)
                toastr.warning('Please fill all \'License Plate\' fields before submitting.');
        } else if (sectionName == 'pets') {
            this.profile.data[sectionName].forEach(i => {
                if (!i.name || !i.petType)
                    isValid = false;
            });
            if (!isValid)
                toastr.warning('Please fill all \'Name\' and \'Type\' fields before submitting.');
        } else if (sectionName == 'userProfile') {
            this.profile.data.phones.forEach(p => {
                if (!p.phone)
                    isValid = false;
            });
            if (!isValid)
                toastr.warning('Please fill all \'Phone\' fields before submitting.');
        }
        return isValid;
    }

    hasPendingChanges(sectionName, item?) {
        let hasChanges = false;
        if (this.profile.data.previousPatch) {
            const patch = this.profile.data.previousPatch;
            if (sectionName == 'pets' || sectionName == 'vehicles')
                hasChanges = patch[sectionName];
            else if (sectionName == 'userProfile')
                hasChanges = (patch['addresses'] && patch['addresses'].length > 0) ||
                    (patch['phones'] && patch['phones'].length > 0) ||
                    (patch.userProfile && (patch.userProfile.avatar || patch.userProfile.dateOfBirth || patch.userProfile.email || patch.userProfile.fullName));
            else if (sectionName == 'emergencyContacts')
                hasChanges = patch.userProfile && patch.userProfile['emergencyContacts'];
            else if (sectionName == 'vehiclesItem')
                hasChanges = Array.isArray(patch.vehicles) ? patch.vehicles.filter(v => !item.id || v.id == item.id).length > 0 : false;
            else if (sectionName == 'petsItem')
                hasChanges = Array.isArray(patch.pets) ? patch.pets.filter(p => !item.id || p.id == item.id).length > 0 : false;
        }
        return hasChanges;
    }

    public addNewContact(): void {
        this.profile.data.userProfile.emergencyContacts.push({
            name: '',
            phone: '',
            email: '',
            relation: '',
            isPrimary: false,
            note: ''
        });
    }

    updatePrimary(index): void {
        if (!this.profile.data.userProfile.emergencyContacts.length) return;
        this.profile.data.userProfile.emergencyContacts.forEach(c => c.isPrimary = false);
        this.profile.data.userProfile.emergencyContacts[index].isPrimary = true;
    }

    private dataIsValid() {
        let valid = true;
        let hasEmpty = false;
        this.profile.data.userProfile.emergencyContacts.forEach((item) => {
            delete item.user;
            delete item.suite;
            if (!item.name && !item.phone && !item.email && !item.relation && !item.note) {
                valid = false;
                hasEmpty = true;
            } else if (item.email && !this.emailIsValid(item.email)) {
                toastr.warning(`Email ${item.email} is invalid.`);
                valid = false;
            }
        });
        if (hasEmpty)
            toastr.warning('At least one field per item must be field.');
        return valid;
    }

    emailIsValid(email) {
        return email.match('[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?');
    }

    remove(index) {
        if (index === 0 && this.profile.data.userProfile.emergencyContacts[index].isPrimary && this.profile.data.userProfile.emergencyContacts[1]) {
            this.updatePrimary(1);
        }
        if (this.profile.data.userProfile.emergencyContacts[index].isPrimary) {
            this.updatePrimary(0);
        }
        this.profile.data.userProfile.emergencyContacts.splice(index, 1);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/profile/profile.component.ts